import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Typography, InputLabel, FormHelperText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Mlt from '@sprinx/react-mui-components/MultilineText';
/**
 * Zakladni komponenta pro zobrazeni hodnoty v readonly modu.
 */

function FieldPreview(_ref) {
  var align = _ref.align,
      alignLabel = _ref.alignLabel,
      classes = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      fullWidth = _ref.fullWidth,
      helperText = _ref.helperText,
      InputProps = _ref.InputProps,
      label = _ref.label,
      margin = _ref.margin,
      size = _ref.size,
      sticky = _ref.sticky,
      style = _ref.style,
      value = _ref.value;
  var variantMap = {
    xsmall: 'caption',
    small: 'body2',
    normal: 'body1',
    large: 'h6'
  };
  var variant = variantMap[size] || 'body1';
  var content = sticky ? /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.inputContent, classes.stickyInputContent, align === 'right' && classes.stickyInputContentRight)
  }, InputProps && InputProps.startAdornment, /*#__PURE__*/React.createElement(Mlt, null, value), InputProps && InputProps.endAdornment) : /*#__PURE__*/React.createElement(React.Fragment, null, InputProps && InputProps.startAdornment, /*#__PURE__*/React.createElement("div", {
    className: classes.inputContent
  }, /*#__PURE__*/React.createElement(Mlt, null, value)), InputProps && InputProps.endAdornment);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.root, className, fullWidth && classes.fullWidth, {
      'none': classes.marginNone,
      'normal': classes.marginNormal,
      'dense': classes.marginDense
    }[margin], align === 'right' && alignLabel && classes['align-right-label']),
    style: style
  }, label && /*#__PURE__*/React.createElement(InputLabel, {
    shrink: true
  }, label), /*#__PURE__*/React.createElement(Typography, {
    className: clsx(classes["align-".concat(align)], classes.input),
    variant: variant,
    component: "div",
    color: color
  }, content), helperText && /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(Mlt, null, helperText)));
}

FieldPreview.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  alignLabel: PropTypes.bool,

  /**
   * @ignore
   */
  classes: PropTypes.shape({
    'align-left': PropTypes.string,
    'align-right': PropTypes.string,
    'align-right-label': PropTypes.string,
    fullWidth: PropTypes.string,
    input: PropTypes.string,
    inputContent: PropTypes.string,
    marginDense: PropTypes.string,
    marginNone: PropTypes.string,
    marginNormal: PropTypes.string,
    root: PropTypes.string,
    stickyInputContent: PropTypes.string,
    stickyInputContentRight: PropTypes.string
  }).isRequired,
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Pomocny text, zobrazovany pod vstupem.
   */
  helperText: PropTypes.string,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({
    endAdornment: PropTypes.node,
    startAdornment: PropTypes.node
  }),

  /**
   * Label fieldu.
   */
  label: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large']),
  sticky: PropTypes.bool,
  style: PropTypes.shape({}),
  value: PropTypes.node
};
FieldPreview.defaultProps = {
  align: 'left',
  alignLabel: false,
  className: undefined,
  color: 'initial',
  fullWidth: false,
  helperText: undefined,
  InputProps: undefined,
  label: undefined,
  margin: 'dense',
  size: undefined,
  sticky: false,
  style: undefined,
  value: null
};
export default withStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: theme.spacing(20),
      '& span': {
        display: 'inline-block'
      }
    },
    input: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      alignItems: 'baseline'
    },
    inputContent: {
      flexGrow: 1,
      width: '100%'
    },
    fullWidth: {
      width: '100%'
    },
    marginNone: {
      marginTop: 0,
      marginBottom: 0
    },
    marginNormal: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    marginDense: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5)
    },
    'align-left': {},
    'align-right': {
      textAlign: 'right'
    },
    'align-right-label': {
      '& > label': {
        transform: 'scale(0.75)',
        textAlign: 'right',
        transformOrigin: 'right'
      }
    },
    stickyInputContent: {
      display: 'flex',
      alignItems: 'baseline'
    },
    stickyInputContentRight: {
      justifyContent: 'flex-end'
    }
  };
}, {
  name: 'SxFieldPreview'
})(FieldPreview);